// extracted by mini-css-extract-plugin
module.exports = {"inputElement":"Input_inputElement__37heq"};